import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useResponsiveClass = (
  elementId: string, 
  mobileClass: string, 
  defaultClass: string
): void => {
  const location = useLocation();

  useEffect(() => {
    // Function to toggle class and adjust padding based on screen width
    const toggleClassNameByWidth = (): void => {
      const pageDiv = document.getElementById(elementId);
      const statusbar = document.getElementById('statusbar');
      
      if (pageDiv) {
        // Apply the responsive class based on the window width
        pageDiv.className = window.innerWidth <= 1150 ? mobileClass : defaultClass;

        // If the class is defaultClass, adjust padding based on statusbar height
        if (pageDiv.classList.contains(defaultClass) && statusbar) {
          const statusbarHeight = statusbar.offsetHeight;
          pageDiv.style.paddingTop = `${statusbarHeight}px`;
        } else {
          // Reset padding if not the defaultClass or statusbar is not present
          pageDiv.style.paddingTop = '0px';
        }
      }
    };

    toggleClassNameByWidth();

    window.addEventListener('resize', toggleClassNameByWidth);

    return () => {
      window.removeEventListener('resize', toggleClassNameByWidth);
    };
  }, [elementId, mobileClass, defaultClass, location.pathname]);
};
